import { render, staticRenderFns } from "./UploadCodeModal.vue?vue&type=template&id=c4584c10&scoped=true&"
import script from "./UploadCodeModal.vue?vue&type=script&lang=js&"
export * from "./UploadCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4584c10",
  null
  
)

export default component.exports